export class ConfigService {
    apiUrl!: string;
}